import './Footer.css';

const Footer = () => {

    return (
        <section className='Footer'>
            <div className='line'></div>
            <a target="_blank" rel='noreferrer' href='http://www.jayasen.com/'>Powered By Jay.Asen</a>
            <div className='line'></div>
        </section>
    );
};

export default Footer;